import { getReportLogic } from "./Reports.logic";

export async function getReport(type, filter) {
  const report = await getReportLogic(type, filter);
  return report;
}
